import { useTags } from 'data/tags'
import { List } from './List'

export const TagList = () => {
  const { tags } = useTags()

  return <List tags={tags} />
}
